import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=4270a1fe"
import script from "../controllers/login-page.js?vue&type=script&lang=js&external"
export * from "../controllers/login-page.js?vue&type=script&lang=js&external"
import style0 from "./LoginPage.vue?vue&type=style&index=0&id=4270a1fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports